"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _org = require("@/api/org");
var _commissionbranches = require("@/api/commissionbranches");
var _Export2Excel = require("@/utils/Export2Excel");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      date: '',
      profitOptions: [{
        key: 1,
        display_name: '渠道商'
      }, {
        key: 2,
        display_name: '运维团队'
      }, {
        key: 3,
        display_name: '设备所属单位'
      }, {
        key: 4,
        display_name: 'C端机构'
      }, {
        key: 5,
        display_name: 'TTS专家工作室'
      }, {
        key: 6,
        display_name: 'TTS方案归属团队'
      }, {
        key: 10,
        display_name: '新汉方公司'
      }],
      dept: [],
      listQuery: {},
      tableData: [],
      listLoading: false
    };
  },
  created: function created() {
    this.getDept();
  },
  methods: {
    checkPermission: _permission.default,
    getDept: function getDept() {
      var _this = this;
      (0, _org.getOrgList)({
        sales_type: 0,
        parent: 1
      }).then(function (response) {
        _this.dept = response.data;
      });
    },
    exportExcel: function () {
      var _exportExcel = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this2 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.listQuery.time === '' || this.listQuery.time === undefined || this.listQuery.time === null)) {
                _context.next = 4;
                break;
              }
              this.$message({
                type: 'error',
                message: '请先选择查询时间!'
              });
              _context.next = 14;
              break;
            case 4:
              if (!(this.listQuery.commission === '' || this.listQuery.commission === undefined || this.listQuery.commission === null)) {
                _context.next = 11;
                break;
              }
              delete this.listQuery.commission;
              _context.next = 8;
              return (0, _commissionbranches.getQuDaoReport)(this.listQuery).then(function (response) {
                if (response.data) {
                  _this2.tableData = response.data;
                  console.log(response.data);
                }
              });
            case 8:
              this.exportExcel1();
              _context.next = 14;
              break;
            case 11:
              _context.next = 13;
              return (0, _commissionbranches.getQuDaoReport)(this.listQuery).then(function (response) {
                if (response.data) {
                  _this2.tableData = response.data;
                  console.log(response.data);
                }
              });
            case 13:
              this.exportExcel2();
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function exportExcel() {
        return _exportExcel.apply(this, arguments);
      }
      return exportExcel;
    }(),
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          if (j === 'timestamp') {
            return (0, _utils.parseTime)(v[j]);
          } else {
            return v[j];
          }
        });
      });
    },
    exportExcel1: function exportExcel1() {
      var multiHeader = [['', '', '', '', '自有订单', '', '', '外部订单', '', '', '', '', '合计订单', '', '', '']]; // 一、二级表头
      var tHeader = ['设备编号', '设备编码', '设备所在机构编号', '机构名称', '患者数量', '调理人次', '调理部位数', '患者数量', '调理人次', '调理部位数', '调理收入', '患者数量', '调理人次', '调理部位数', '调理收入']; // 三级表头
      var filterVal = ['device_number', 'device_name', 'receiving_medical_no', 'receiving_medical_name', 'offline_huser_num', 'offline_treatment_num', 'offline_treatmentpart_num', 'online_huser_num', 'online_treatment_num', 'online_treatmentpart_num', 'online_revenue', 'total_huser_num', 'total_treatment_num', 'total_treatmentpart_num', 'total_revenue']; // 表头所对应后台返回的字段
      // const data = this.excelData.map(v => filterVal.map(j => v[j]));//这一行和下面得六行代码是一样得作用的
      var list = this.tableData;
      // if (this.tableData === 0) {
      //   list = this.tableData
      // } else {
      //   list = this.tableData
      // }
      var data = this.formatJson(filterVal, list); // 格式化
      console.log(data);
      // 如果没有合并得从上往下写，遇到开始合并单元格的，从左往右得单行写，从上到下，直到写完整
      var merges = ['A1:B1', 'C1:D1', 'E1:G1', 'H1:L1', 'M1:P1'];
      (0, _Export2Excel.export_json_to_excel)({
        multiHeader: multiHeader,
        // 这里是第一行的表头
        header: tHeader,
        // 这里应该是算第二行的表头
        data: data,
        // 数据
        merges: merges,
        // 合并行
        filename: '渠道分润报表' + '_' + new Date().getTime(),
        autoWidth: true,
        bookType: 'xlsx'
      });
    },
    exportExcel2: function exportExcel2() {
      var multiHeader = [['分润单位名称', '', '自有订单', '', '', '外部订单', '', '', '', '', '合计订单', '', '', '']]; // 一、二级表头
      var tHeader = ['[分润单位]编号', '[分润单位]名称', '患者数量', '调理人次', '调理部位数', '患者数量', '调理人次', '调理次数', '调理部位数', '调理收入', '患者数量', '调理人次', '调理部位数', '调理收入']; // 三级表头
      var filterVal = ['commission_dept_no', 'commission_dept_name', 'offline_huser_num', 'offline_treatment_num', 'offline_treatmentpart_num', 'online_huser_num', 'online_treatment_num', 'online_treatment_num', 'online_treatmentpart_num', 'online_revenue', 'total_huser_num', 'total_treatment_num', 'total_treatmentpart_num', 'total_revenue']; // 表头所对应后台返回的字段
      // const data = this.excelData.map(v => filterVal.map(j => v[j]));//这一行和下面得六行代码是一样得作用的
      var list = this.tableData;
      // if (this.tableData === 0) {
      //   list = this.tableData
      // } else {
      //   list = this.tableData
      // }
      var data = this.formatJson(filterVal, list); // 格式化
      console.log(data);
      // 如果没有合并得从上往下写，遇到开始合并单元格的，从左往右得单行写，从上到下，直到写完整
      var merges = ['A1:B1', 'C1:E1', 'F1:J1', 'K1:N1'];
      (0, _Export2Excel.export_json_to_excel)({
        multiHeader: multiHeader,
        // 这里是第一行的表头
        header: tHeader,
        // 这里应该是算第二行的表头
        data: data,
        // 数据
        merges: merges,
        // 合并行
        filename: '渠道分润报表' + '_' + new Date().getTime(),
        autoWidth: true,
        bookType: 'xlsx'
      });
    }
  }
};